import { Sheet, type SmoothieSheetProps } from './Sheet';

interface TallSheetProps extends Pick<
    SmoothieSheetProps,
    | 'isOpen'
    | 'onClose'
    | 'title'
    | 'subtitle'
    | 'showCloseButton'
    | 'headerLeftAction'
    | 'children'
    | 'disableDrag'
    | 'dismissOnOverlayPress'
    | 'isInsideModal'
    | 'withPadding'
    | 'forceKeyboardCompatibleBottomSheet'
    | 'contentScrollRef'
    | 'onContentScroll'
    | 'titleLineHeight'
> {}

/**
 * TallSheet is a wrapper around Sheet that calculates the fixed height
 * and enables the scroll gradient.
 */
export const TallSheet = ({
    isOpen,
    onClose,
    title,
    subtitle,
    showCloseButton,
    headerLeftAction,
    children,
    disableDrag = true,
    dismissOnOverlayPress = true,
    isInsideModal,
    withPadding = true,
    forceKeyboardCompatibleBottomSheet = false,
    contentScrollRef,
    onContentScroll,
    titleLineHeight,
}: TallSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            showCloseButton={showCloseButton}
            headerLeftAction={headerLeftAction}
            disableDrag={disableDrag}
            dismissOnOverlayPress={dismissOnOverlayPress}
            isInsideModal={isInsideModal}
            withPadding={withPadding}
            forceKeyboardCompatibleBottomSheet={
                forceKeyboardCompatibleBottomSheet
            }
            forceMaxContentHeight={true}
            contentScrollRef={contentScrollRef}
            onContentScroll={onContentScroll}
            titleLineHeight={titleLineHeight}
        >
            {children}
        </Sheet>
    );
};
